import React from 'react';

function ShippingPolicy() {
  return (
    <div class="container py-5 my-md-5">
      <h1>Shipping Policy for Acadverse Technologies Private Limited</h1>
      <p>
        Not applicable
      </p>
    </div>
  );
}

export default ShippingPolicy;
